function normalizeNewsletter(value = "") {
    return value.toLowerCase().replace(/[^a-z0-9]+/g, "").trim();
}

function bindNewsletterPage(page) {
    if (!page || page.dataset.newsletterBound === "1") return;

    const form = page.querySelector("[data-newsletter-signup-form]");
    const choices = page.querySelector("[data-newsletter-choices]");
    const submit = page.querySelector("[data-newsletter-submit]");
    const submitLabel = page.querySelector("[data-newsletter-submit-label]");
    const options = Array.from(page.querySelectorAll("[data-newsletter-option]"));
    const inputs = options.map(option => option.querySelector("[data-members-newsletter]")).filter(Boolean);

    if (!form || !choices || !submit || !submitLabel) {
        page.dataset.newsletterBound = "1";
        return;
    }

    const selectedInputs = () => inputs.filter(input => input.checked);

    const sync = () => {
        const selected = selectedInputs();
        options.forEach(option => {
            const input = option.querySelector("[data-members-newsletter]");
            option.classList.toggle("is-selected", Boolean(input?.checked));
        });
        submit.type = selected.length ? "submit" : "button";
        submitLabel.textContent = selected.length
            ? `Subscribe to ${selected.map(input => input.value).join(" + ")}`
            : "Choose your newsletter";
    };

    const openChoices = () => {
        choices.hidden = false;
        page.classList.add("is-choosing-newsletter");
        choices.querySelector("input")?.focus({preventScroll: true});
    };

    const closeChoices = () => {
        choices.hidden = true;
        page.classList.remove("is-choosing-newsletter");
    };

    submit.addEventListener("click", event => {
        if (selectedInputs().length) return;
        event.preventDefault();
        openChoices();
    });

    inputs.forEach(input => input.addEventListener("change", sync));

    page.querySelectorAll("[data-newsletter-card]").forEach(card => {
        const aliases = (card.dataset.newsletterAliases || "")
            .split("|")
            .map(normalizeNewsletter)
            .filter(Boolean);

        card.querySelectorAll("[data-newsletter-select]").forEach(action => {
            action.addEventListener("click", event => {
                event.preventDefault();
                const matched = options.find(option => {
                    const name = normalizeNewsletter(option.dataset.newsletterName);
                    const slug = normalizeNewsletter(option.dataset.newsletterSlug);
                    return aliases.includes(name) || aliases.includes(slug);
                });

                if (matched) {
                    inputs.forEach(input => {
                        input.checked = false;
                    });
                    const input = matched.querySelector("[data-members-newsletter]");
                    if (input) input.checked = true;
                    sync();
                    closeChoices();
                } else {
                    openChoices();
                }

                form.scrollIntoView({behavior: "smooth", block: "center"});
            });
        });
    });

    sync();
    page.dataset.newsletterBound = "1";
}

export default function initNewsletters(root = document) {
    root.querySelectorAll("[data-newsletter-page]").forEach(bindNewsletterPage);
}
